export function Footer() {
    return (
        <div
            className="footer dark jumbotron"
            style={{ marginBottom: "0px", backgroundColor: "#343434", color: "floralwhite" }}
        >
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-auto" style={{ textAlign: "center" }}>
                        <p>© Copyright 2024 Weather Erudite. All Rights Reserved.</p>
                        <p>
                            Created and maintained by <a href="https://www.shikharbhadauria.com/">Shikhar Singh.</a>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
}
